import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const emptyMetrics = {
  posts: 0,
  reviews: 0,
  comments: 0,
  foodlist: 0,
  recipes: 0,
};

const useUserMetrics = () => {
  const { user } = useAuth();
  const [metrics, setMetrics] = useState(emptyMetrics);
  const [loading, setLoading] = useState(false);

  const fetchMetrics = useCallback(async () => {
    if (!user) {
      setMetrics(emptyMetrics);
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/activity/metrics`, { credentials: 'include' });
      if (!res.ok) throw new Error('Failed to load metrics');
      const data = await res.json();
      setMetrics({
        posts: data.posts_count || 0,
        reviews: data.reviews_count || 0,
        comments: data.comments_count || 0,
        foodlist: data.foodlist_count || 0,
        recipes: data.recipes_count || 0,
      });
    } catch {
      setMetrics(emptyMetrics);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { metrics, loading, refresh: fetchMetrics };
};

export default useUserMetrics;
